<tilby-dialog-toolbar class="tw-px-2 tw-pt-2" [title]="data.titleToolbar" (confirm)="confirm()"/>
<tilby-dialog-content class="tw-flex tw-flex-col tw-gap-4 tw-h-[calc(100vh/1.5)] tw-w-[calc(100vh + 500px)]">
    <input #searchTextField id="searchTextField" type="text" size="50" placeholder="{{'SETTINGS.ALVOLO.GENERALS.PLACEHOLDER_MAP' | translate}}">
    <div #map id="map" class="tw-h-[calc(100vh/2)]"></div>
</tilby-dialog-content>
